export function foo() {
  return "foo";
}
